export default __webpack_public_path__ + "static/hoer-logo-04c4bce91b2cb5024f82a736561074d0.svg";